import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/HomePage.vue'
import ArtistsPage from '../views/ArtistsPage.vue'
import ArtistPage from '../views/ArtistPage.vue'
import ProjectPage from '../views/ProjectPage.vue'
import VisitPage from '@/views/VisitPage.vue'
import VirtualExhibitionPage from '../views/VirtualExhibitionPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/concept',
    name: 'Concept',
    component: () => import('../views/ConceptPage.vue')
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: () => import('../views/IntroductionPage.vue')
  },
  {
    path: '/artists',
    name: 'Artists',
    component: ArtistsPage
  },
  {
    path: '/visit',
    name: 'Visit',
    component: VisitPage
  },
  {
    path: '/game',
    name: 'Game',
    component: () => import('../views/GamePage.vue')
  },
  {
    path: '/virtual-exhibition',
    name: 'VirtualExhibition',
    component: VirtualExhibitionPage
  },
  {
    path: '/artist/:id',
    name: 'ArtistPage',
    component: ArtistPage,
    meta: {
      hideHeaderFooter: true
    }
  },
  {
    path: '/project/:id',
    name: 'ProjectPage',
    component: ProjectPage,
    meta: {
      hideHeaderFooter: true
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // 显示加载动画
  const app = document.getElementById('app').__vue__;
  if (app) {
    app.isLoading = true;
  }
  // 检查这里是否有阻止导航到 /visit 的逻辑
  next()
})

router.afterEach(() => {
  // 隐藏加载动画
  setTimeout(() => {
    const app = document.getElementById('app').__vue__;
    if (app) {
      app.isLoading = false;
    }
  }, 500); // 短暂延迟以确保页面有时间渲染
})

export default router